import type {FC} from 'react';
import ReactSkeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

import Color from 'color';
import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props} from './types';

import {getColor} from '../../styles';
import {skeletonStyle} from './styles';

const StyledSkeleton = styled(ReactSkeleton).attrs<Props>(p => {
  const boneColor = p.boneColor || getColor('background2')(p);
  const highlightColor =
    p.theme.id === 'light'
      ? Color(boneColor).darken(0.03).toString()
      : Color(boneColor).lighten(0.2).toString();

  return {
    baseColor: boneColor,
    highlightColor,
  };
})<Props>`
  ${skeletonStyle};
`;

export const Skeleton: FC<WithDomStyleProp<Props>> = ({testID, ...props}) => {
  return <StyledSkeleton containerTestId={testID} {...props} />;
};
